export default {
    localeName: "cs",
    common: {
        done: "Hotovo",
        record: "Zaznamenat",
        activate: "Aktivovat",
        evaluate: "Hodnotit",
        add: "Přidat",
        create: "Vytvořit",
        detail: "Detail",
        admin: "Administrátor",
        manager: "Manažer",
        socialWorker: "Pečovatel",
        worker: "Pečovatel",
        volunteer: "Dobrovolník",
        save: "Uložit",
        month: "Měsíc",
        week: "Týden",
        yes: "Ano",
        no: "Ne",
        active: "Aktivní",
        inactive: "Neaktivní",
        edit: "Upravit",
        close: "Zavřít",
        clear: "Vymazat",
        delete: "Smazat",
        search: "Hledat...",
        searchHint: "Pro začátek vyhledávání napište hledanou frázi...",
        change: "Změnit",
        cancel: "Zrušit",
        noRecords: "Nebyly nalezeny žádné záznamy.",
        deleteItemMessage: "Opravdu chcete smazat tuto položku?",
        relationship: "Příbuzenský vztah",
        rowsPerPage: "Počet řádků na stránku",
        clearFilters: "Smazat filtry",
        paidTask: "Úkon",
        paidTasks: "Úkony",
        freeTask: "Přání",
        back: "Zpět",
        all: "Vše",
        upload: "Nahrát",
        download: "Stáhnout",
        openInNewTab: "Otevřít v novém okně",
        confirm: "Potvrdit",
        show: "Zobrazit",
        name: "Název",
        reload: "Znovu načíst"
    },
    validation: {
        thisFieldIsRequired: "Toto pole je povinné.",
        wrongTimeFormat: "Neplatný formát času."
    },
    days: {
        mo: "po",
        tu: "út",
        we: "st",
        th: "čt",
        fr: "pá",
        sa: "so",
        su: "ne"
    },
    components: {
        chooseClient: "Vybrat klienta",
        chooseDistrict: "Vybrat středisko",
        chooseTown: "Vybrat obec",
        chooseSocialWorker: "Vybrat pečovatele",
        chooseMainCareProvider: "Vybrat klíčového pracovníka",
        chooseOtherCareProvider: "Vybrat dalšího pečovatele",
        chooseState: "Vybrat stav",
        chooseAccountType: "Vybrat typ účtu",
        chooseCatalogItemType: "Vybrat typ úkonu",
        choosePaymentMethod: "Vybrat platební metodu",
        dateSince: "Datum od",
        dateUntil: "Datum do",
        export: "Exportovat",
        startExport: "Zahájit export do Excel",
        district: "Středisko",
        town: "Obec",
        socialWorkers: "Pečovatelé",
        unsavedChanges: "Neuložené změny",
        unsavedChangesText: "Zaregistrovali jsme neuložené změny. Chcete je před zavřením uložit?",
        saveChanges: "Uložit změny",
        closeWithoutSave: "Zavřít bez uložení"
    },
    menu: {
        dashboard: 'Nástěnka',
        workTasks: "Plán práce",
        newWorkTasks: "Úkony klientů",
        visits: "Předpis návštěv",
        clientsEvaluation: "Hodnocení klientských úkonů",
        statements: "Provedené úkony",
        clients: "Klienti",
        cloud: "Soubory",
        reports: "Reporty",
        settings: "Nastavení"
    },
    authentification: {
        signIn: "Přihlásit",
        signUp: "Registrovat se",
        registration: "Registrace",
        passwordRecovery: "Obnova hesla",
        createAccount: "Vytvořit účet",
        firstName: "Jméno",
        lastName: "Příjmení",
        email: "Email",
        phoneNumber: "Telefonní číslo",
        registeredEmail: "Registrační email",
        password: "Heslo",
        passwordAgain: "Heslo znovu",
        newPassword: "Nové heslo",
        newPasswordAgain: "Nové heslo znovu",
        weWillSendYouRecoveryEmail: "Odešleme Vám odkaz pro obnovu hesla na registrační email.",
        requestPasswordReset: "Požádat o obnovu hesla",
        changePassword: "Změnit heslo",
        goToSignIn: "Jít na přihlašovací stránku",
        toast: {
            passwordRecovered: "Heslo úspěšně obnoveno",
            passwordRecoveredText: "Heslo bylo úspěšně obnoveno, můžete se přihlásit.",
            passwordNotRecovered: "Heslo se nepodařilo obnovit",
            passwordNotRecoveredText: "Během obnovení hesla se vyskytla chyba. Zkontrolujte token a zkuste znovu.",
            userNotFound: "Uživatel nebyl nalezen",
            userNotFoundText: "Uživatel se zadaným e-mailem nebyl nalezen. Zkuste prosím znovu.",
            passwordRecoveryRequestSent: "Žádost o obnovu hesla byla úspěšně zpracována",
            passwordRecoveryRequestSentText: "Na Vaší e-mailovou adresu byl odeslán potvrzovací odkaz pro obnovu."
        },
        registrationWasSuccessful: "Registrace byla provedena. Na e-mailovou adresu Vám byl zaslán aktivační e-mail.",
        activationLinkVerified: "Aktivační odkaz byl úspěšně ověřen. Nyní se můžete přihlásit.",
        verifyingActivationLink: "Probíhá ověřování aktivačního odkazu...",
        activationLinkFailed: "Aktivační odkaz se nepodařilo ověřit.",
        enteredPasswordsMustMatch: "Zadaná hesla se musí shodovat.",
        invalidLength: "Heslo musí být minimálně 6 znaků dlouhé.",
        errors: {
            signInFailed: "Nebylo možné se přihlásit. Prosím zkontrolujte přihlašovací údaje.",
            duplicateUserName: "Účet s touto e-mailovou adresou již existuje.",
            signUpError: "Při registraci nastala chyba."
        },
        twoFactor: {
            enterCode: "Zadejte Váš SMS kód:",
            SMSSent: "SMS s kódem jsme odeslali na Vaše telefonní číslo.",
            notReceivedSMS: "Nepřišel Vám kód?",
            sendAgain: "Odeslat znovu"
        }
    },
    dashboard: {
        todayPlan: "Dnešní plán střediska",
        today: "Dnes",
        todayWorkTaskCount: "počet úkonů",
        todayClientCount: "počet klientů",
        todayNewClientCount: "noví klienti",
        todayEvaluationCount: "počet hodnocení",
        todayNewPaidTaskCount: "nové úkony",
        todayFreeTaskCount: "nová přání",
        workTasks: "Úkony",
        clientEvalutions: "Hodnocení klientských úkonů",
        newClients: "Noví klienti",
        newTasks: "Nové úkony",
        manager: "Manažer (koordinátor)",
        call: "Volat"
    },
    workTasks: {
        showTable: "Zobrazit v tabulce",
        showKanban: "Zobrazit v kanbanu",
        addUnplannedTask: "Přidat neplánovaný úkon",
        notApproved: "Neschválené",
        other: "Ostatní",
        done: "Hotové",
        finished: "Dokončeno",
        workTaskCount: "Počet úkolů",
        createWish: "Vytvořit přání"
    },
    newWorkTasks: {
        table: {
            headers: {
                client: "Klient",
                district: "Středisko",
                town: "Obec",
                newWorkTask: "Nový úkon",
                mainCareProvider: "Klíčový pracovník",
                phoneNumber: "Telefonní číslo",
                status: "Stav"
            }
        },
        state: {
            active: "Aktivní",
            new: "Nový"
        },
        buttons: {
            activate: "Aktivovat",
            detail: "Detail"
        }
    },
    clientsEvaluation: {
        table: {
            headers: {
                client: "Klient",
                district: "Středisko",
                town: "Obec",
                address: "Adresa",
                mainCareProvider: "Klíčový pracovník",
                phoneNumber: "Telefonní číslo",
                status: "Stav",
                date: "Datum"
            }
        },
        state: {
            active: "Aktivní",
            new: "Nový"
        },
        buttons: {
            evaluate: "Hodnotit",
            detail: "Detail"
        },
        planned: "Plánované",
        done: "Hotové"
    },
    statements: {
        columnClient: "Klient",
        columnSocialWorker: "Pečovatel",
        columnTask: "Úkon",
        columnPricePerUnit: "Cena za jednotku",
        columnDate: "Datum",
        columnAmount: "Množství",
        columnPrice: "Cena",
        columnPaymentMethod: "Platební metoda",
        columnDistrict: "Středisko",
        columnTown: "Město",
        newItem: "Nový záznam"
    },
    clients: {
        columnName: "Název",
        columnDistrict: "Středisko",
        columnTown: "Obec",
        columnMainCareProvider: "Klíčový pracovník",
        columnPhoneNumber: "Telefonní číslo",
        columnEmail: "E-mail",
        columnState: "Stav",
        columnAddress: "Adresa",
        addClient: "Přidat klienta",
        clientCount: "Počet klientů"
    },
    client: {
        menu: {
            general: "Obecné",
            visitPlan: "Předpis návštěv",
            information: "Zdravotní informace",
            rules: "Úkony",
            statements: "Provedené úkony",
            taskEvaluations: "Hodnocení úkonů",
            evaluations: "Hodnocení klienta",
            needs: "Potřeby",
            socialInquiries: "Sociální šetření",
            comments: "Denní záznamy",
            files: "Soubory",
            interest: "Zájem"
        },
        general: {
            firstName: "Jméno",
            lastName: "Příjmení",
            startDate: "Zahájení péče",
            endDate: "Ukončení péče",
            state: "Stav",
            district: "Středisko",
            town: "Obec",
            entrustedKeys: "Svěřené klíče",
            contract: "Smlouva",
            generatedId: "ID Klienta",
            personalNumber: "Osobní číslo (ID)",
            phoneNumber: "Telefonní číslo",
            email: "E-mail",
            mainCareProvider: "Klíčový pracovník",
            importantContacts: "Důležité kontakty",
            deleteClient: "Smazat klienta",
            deleteClientMessage: "Opravdu chcete smazat klienta \"{name}\"?",
            careProviders: "Ostatní poskytovatelé péče",
            paidTasks: "Úkony",
            freeTasks: "Přání"
        },
        information: {
            payments: "Platby",
            accountNumber: "Číslo účtu",
            secondAccountNumber: "2. číslo účtu",
            paymentVariableSymbol: "Variabilní symbol",
            careAllowence: "Příspěvek na péči",
            street: "Ulice a číslo popisné",
            city: "Město",
            floor: "Pokoj/patro",
            zip: "PSČ",
            dateOfBirth: "Datum narození",
            maritalStatus: "Rodinný stav",
            legalCapacity: "Svéprávnost",
            levelOfDisability: "ZTP",
            benefitClaim: "Zvýhodnění",
            notes: "Poznámky",
            risk: "Rizika",
            reason: "Důvod žádosti",
            howLearnedAboutUs: "Odkud se o nás zájemce dozvěděl",
            conditionBeforeStart: "Stav před zahájením poskytování péče",
            interestDescription: "Další informace o zájemci",
            medicalInfoHeader: "Zdravotní informace",
            doctorName: "Jméno ošetřujícího lékaře",
            doctorPhoneNumber: "Telefon ošetřujícího lékaře",
            hospitalName: "Název ošetřující nemocnice",
            hospitalAddress: "Adresa nemocnice",
            medicalProblems: "Zdravotní potíže",
            medicalRestrictions: "Zdravotní omezení",
            incontinence: "Inkotinence",
            otherMedicalInformation: "Ostatní zdravotní informace",
            insideMobility: "Pohyblivost uvnitř",
            outsideMobility: "Pohyblivost venku"
        },
        rules: {
            regular: "Pravidelný",
            oneTime: "Nárazový",
            start: "Zahájení",
            end: "Ukončení",
            state: "Stav",
            repetition: "Opakování",
            repeatEvery: "Opakovat každý",
            // preferredTime: "Kolikrát za den a preferovaný čas",
            preferredTime: "Preferovaný čas",
            nextBusinessDayOnHoliday: "V případě svátků plánovat na nejbližší poskytovaný den",
            description: "Popis",
            reason: "Důvod poskytnutí",
            goal: "Cíl",
            desire: "Přání klienta",
            risk: "Rizika",
            tools: "Pomůcky",
            deleteRule: "Smazat úkon",
            deleteRuleMessage: "Opravdu chcete smazat úkon?",
        },
        statements: { },
        evaluations: {
            nextEvaluationDate: "Datum plánovaného hodnocení",
            history: "Historie",
            evaluate: "Hodnotit",
            dateOfEvaluation: "Datum záznamu",
            addEvaluation: "Přidat hodnocení",
            detailOfEvaluation: "Detail hodnocení",
            new: "Nové",
            deleteEvaluation: "Smazat hodnocení",
            deleteEvaluationMessage: "Opravdu chcete smazat hodnocení ze dne"
        },
        clientEvaluations: {
            evaluations: "Hodnocení klienta",
            writeEvaluation: "Napište hodnocení",
        },
        needs: {
            record: "Zaznamenat",
            dateOfRecord: "Datum záznamu",
            deleteNeed: "Smazat potřeby",
            deleteNeedMessage: "Opravdu chcete smazat potřeby ze dne"
        },
        socialInquiries: {
            record: "Zaznamenat",
            dateOfRecord: "Datum záznamu",
            deleteSocialInquiry: "Smazat soc. šetření",
            deleteSocialInquiryMessage: "Opravdu chcete smazat soc. šetření ze dne"
        },
        comments: {
            comments: "Denní záznamy",
            writeComment: "Napište denní záznam",
        }
    },
    cloud: {
        uploadFile: "Nahrát soubor",
        createFolder: "Vytvořit složku",
        newFolderName: "Název nové složky",
        addFolder: "Přidat složku",
        renameFolder: "Přejmenovat složku",
        deleteFolder: "Smazat složku",
        renameFile: "Přejmenovat soubor",
        deleteFile: "Smazat soubor",
        saveFile: "Uložit soubor",
        downloadFile: "Stáhnout soubor",
        createDate: "Datum vytvoření",
        enterFileName: "Zadejte název souboru...",
        deleteFolderMessage: "Opravdu chcete smazat složku"
    },
    reports: {
        count: "Počet",
        active: "aktivních",
        archived: "archivovaných",
        done: "hotových",
        new: "nových",
        clients: "klientů",
        tasks: "úkonů",
        evaluations: "hodnocení",
        managers: "manažerů",
        socialWorkers: "pečovatelů",
        wishes: "přání"
    },
    settings: {
        menu: {
            users: "Zaměstnanci",
            catalog: "Katalog úkonů",
            organization: "Organizace",
            districts: "Střediska",
            needs: "Potřeby",
            socialInquiries: "Soc. šetření"
        },
        accounts: {
            inviteToOrganization: "Pozvat do organizace",
            invite: "Pozvat",
            deleteInvitation: "Smazat pozvánku",
            deleteInvitationConfimMessage: "Opravdu chcete smazat pozvánku pro zaměstnance {email}?",
            deleteUser: "Smazat zaměstnance",
            deleteUserConfirmMessage: "Opravdu chcete odstranit zaměstnance {email}?",
            invitations: "Pozvánky",
            columnName: "Jméno a příjmení",
            columnPhoneNumber: "Telefon",
            columnEmail: "E-mail",
            columnAccountType: "Typ účtu",
            columnManager: "Manažer",
            columnDistrict: "Hlavní středisko",
            districts: "Střediska",
            removeDistrict: "Odstranit středisko",
            addDistrict: "Přidat středisko",
            avatar: "Profilová fotka"
        },
        catalogue: {
            state: "Stav",
            active: "Aktivní",
            notActive: "Neaktivní",
            deleteRule: "Smazat úkon",
            deleteRuleMessage: "Opravdu chcete odstranit položku \"{name}\"?",
            ruleName: "Název úkonu",
            unit: "Jednotka úkonu",
            price: "Cena úkonu",
            reportedUnit: "Vykazovaná jednotka úkonu",
            description: "Popis",
        },
        organization: {
            name: "Název organizace",
            street: "Ulice a číslo popisné",
            city: "Město",
            zip: "PSČ",
            identificationNumber: "IČ",
            vat: "DIČ",
            accountNumber: "Číslo účtu",
            repeatHeader: "Nastavení opakování hodnocení",
            repeatEvery: "Opakovat každý",
            organizationIcon: "Ikona organizace"
        },
        districts: {
            createDistrict: "Vytvořit středisko",
            towns: "Obce",
            district: "Středisko",
            districtName: "Název střediska",
            deleteDistrict: "Smazat středisko",
            deleteDistrictMessage: "Opravdu chcete smazat středisko \"{name}\"?",
            town: "Obec",
            townName: "Název obce",
            deleteTown: "Smazat obec",
            deleteTownMessage: "Opravdu chcete smazat obec \"{name}\"?"
        },
        needs: {
            needItem: "Položka potřeby",
            questionText: "Text otázky",
            deleteNeed: "Smazat položku",
            deleteNeedMessage: "Opravdu chcete smazat položku \"{name}\"?"
        },
        socialInquiries: {
            socialInquiryItem: "Položka soc. šetření",
            questionText: "Text otázky",
            deleteSocialInquiry: "Smazat položku",
            deleteSocialInquiryMessage: "Opravdu chcete smazat položku \"{name}\"?"
        }
    },
    account: {
        header: "Uživatelské nastavení",
        firstname: "Jméno",
        lastName: "Příjmení",
        phoneNumber: "Telefonní číslo",
        twoFactor: "Dvoufázové ověření (SMS PIN)",
        email: "E-mail",
        profilePhoto: "Profilová fotka",
        upload: "Nahrát",
        passwordChange: "Změna hesla",
        oldPassword: "Staré heslo",
        password: "Heslo",
        passwordAgain: "Heslo znovu",
        connectedOrganizations: "Připojené organizace",
        disconnectFromOrganization: "Odpojit od organizace",
        disconnect: "Odpojit",
        invitations: "Pozvánky do organizace",
        invitationsLabel: "Máte následující pozvánky k připojení do těchto organizací",
        connectToOrganization: "Připojit k organizaci",
        deleteInvitation: "Smazat pozvánku",
        deleteOrganization: "Odpojit od organizace",
        deleteOrganizationMessage: "Opravdu se chcete odpojit od organizace {name}?",
        passwordsHasToMatch: "Nová hesla se musejí shodovat.",
        checkPassword: "Nová heslo nemohlo být uloženo, prosím zkontrolujte hesla.",
        passwordSaved: "Nové heslo bylo uloženo.",
        avatar: "Profilová fotka",
        createOrganization: "Vytvořit organizaci",
        selectLanguage: "Vyberte jazyk"
    },
    organizationSignUp: {
        organizationSignUp: "Registrace organizace",
        organizationName: "Název organizace",
        identificationNumber: "IČO",
        vat: "DIČ",
        street: "Ulice",
        postalCode: "PSČ",
        city: "Město",
        signUp: "Registrovat organizaci"
    },
    methods: {
        formatItemCount: (e: number) => {
            if (e == 1)
                return e.toString().concat(" položka");
            else if (e >= 2 && e <= 4)
                return e.toString().concat(" položky");
            else
                return e.toString().concat(" položek");
        }
    },
    codebooks: {
        partyState: {
            active: "Aktivní",
            archived: "Archivovaný",
            interested: "Nový"
        },
        workTaskState: {
            new: "Nový",
            inactive: "Neaktivní",
            active: "Aktivní"
        },
        martialStatus: {
            marriedMan: "Ženatý",
            marriedWoman: "Vdaná",
            divorced: "Rozvedený/á",
            single: "Svobodný/á",
            notSpecified: "Neuvádí se",
            widower: "Vdova / Vdovec"
        },
        legalCapacity: {
            withRestrictions: "S omezením",
            withoutRestrictions: "Bez omezení"
        },
        levelOfDisability: {
            none: "Není",
            ztp: "ZTP",
            ztpp: "ZTP/P"
        },
        paymentMethod: {
            bankAccount: "Převodem",
            cash: "Hotově"
        },
        unitsOfMeasure: {
            piece: "kus",
            pcs: "ks",
            minute: "minuta",
            min: "min.",
            hour: "hodina",
            h: "hod.",
            kilogram: "kilo",
            kg: "kg",
            km: "km",
            kilometer: "Kilometr"
        }
    },
    partyVisitPlan: {
        workTasks: "Prováděné úkony",
        addVisitPlan: "Přidat předpis návštěv",
        editVisitPlan: "Upravit předpis návštěv",
        deleteVisitPlan: "Odstranit předpis návštěv",
        deleteVisitPlanMessage: "Opravdu chcete smazat tento předpis návštěv?"
    }
}
